import Blog1 from './Blog1';

export default Blog1;
